var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MasterDetail',{attrs:{"formTitle":"Cadastro de Etapas ICT","cols":_vm.cols,"opts":_vm.opts,"customResource":_vm.customResource,"descriptionProperty":"nome","serverPagination":""}})}
var staticRenderFns = []

export { render, staticRenderFns }